import { z } from "zod";
// For select options
export const options = { id: z.string(), name: z.string() };
